import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { readConsent, grantAnalytics, denyAnalytics, CONSENT_EVENT } from '../lib/consent';

// Asked once per browser. Both choices carry the same weight by design.
export const AnalyticsConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (readConsent() !== null) return undefined;
    // Long enough that it never competes with the first paint or a sign-in toast.
    const id = setTimeout(() => setShow(true), 1800);
    // The same choice can be made from Account Settings, so stand down if it is.
    const onChange = () => setShow(false);
    window.addEventListener(CONSENT_EVENT, onChange);
    return () => {
      clearTimeout(id);
      window.removeEventListener(CONSENT_EVENT, onChange);
    };
  }, []);

  if (!show) return null;

  const choose = (allow) => {
    if (allow) grantAnalytics();
    else denyAnalytics();
    setShow(false);
  };

  return (
    <div
      className="consent-sheet"
      role="region"
      aria-label="Optional analytics"
      data-testid="analytics-consent"
    >
      <h2 className="consent-sheet-title">Help us improve irecommend</h2>
      <p className="consent-sheet-text">
        We&apos;d like to use Google Analytics to understand how irecommend is used.
        Analytics is optional and isn&apos;t used for advertising.
      </p>
      <p className="consent-sheet-text">
        <Link
          className="consent-sheet-link"
          to="/privacy"
          data-testid="analytics-consent-privacy-link"
        >
          Privacy Statement
        </Link>
      </p>
      <div className="consent-sheet-actions">
        <button
          type="button"
          className="consent-sheet-btn"
          onClick={() => choose(true)}
          data-testid="analytics-consent-allow"
        >
          Allow analytics
        </button>
        <button
          type="button"
          className="consent-sheet-btn"
          onClick={() => choose(false)}
          data-testid="analytics-consent-decline"
        >
          Decline
        </button>
      </div>
    </div>
  );
};
